'use client';

import { DisclosureTooltip } from '@ria-client/tw-shared-ui';

import { HelpOutlineIcon } from '../icons';

export interface StatTileProps {
  label: string;
  value: string;
  tooltip?: string;
  centered?: boolean;
}

export function StatTile({ label, value, tooltip, centered = false }: StatTileProps) {
  return (
    <div
      className={`flex flex-col rounded-advisor-card-control border border-border px-3 py-[18px] ${
        centered ? 'items-center text-center' : 'items-start text-left'
      }`}
    >
      <div className="mb-1 flex items-center gap-0.5 text-[var(--content-neutral-dark)]">
        <span className="typography-text-extra-small font-semibold tracking-[0.5px] uppercase">
          {label}
        </span>
        {tooltip ? (
          <DisclosureTooltip
            placement="top"
            className="max-w-80 !px-2 py-3"
            trigger={
              <button
                type="button"
                aria-label={`What is ${label}?`}
                className="inline-flex cursor-help items-center p-0 text-[var(--content-neutral-main)] hover:text-[var(--content-neutral-darker)]"
              >
                <HelpOutlineIcon className="size-3.5" />
              </button>
            }
          >
            <span className="typography-text-small">{tooltip}</span>
          </DisclosureTooltip>
        ) : null}
      </div>
      <span className="typography-text-bold text-[0.9375rem] text-foreground">{value}</span>
    </div>
  );
}
